"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaShipmentApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class SkubanaShipmentApiClient extends BaseApiClient_1.BaseApiClient {
    async createExternalShipment(externalShipment) {
        const path = `/v1.1/shipment/external`;
        return await this.request("put", path, undefined, externalShipment);
    }
    async createStandardShipment(standardShipment) {
        const path = `/v1.1/shipment/standard`;
        return await this.request("put", path, undefined, standardShipment);
    }
    async getBillingTypes(carrierId) {
        const path = `/v1/shipment/billingtypes/${carrierId || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
    async retrieveShippingCarriers() {
        const path = `/v1/shipment/carriers`;
        return await this.request("get", path, undefined, undefined);
    }
    async retrieveShippingPackages(queryParams) {
        const path = `/v1/shipment/packages`;
        return await this.request("get", path, queryParams, undefined);
    }
    async retrieveShippingPackages2(carrierId) {
        const path = `/v1/shipment/packages/${carrierId || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
    async retrieveShippingProviders() {
        const path = `/v1/shipment/providers`;
        return await this.request("get", path, undefined, undefined);
    }
    async retrieveShippingServices(queryParams) {
        const path = `/v1/shipment/services`;
        return await this.request("get", path, queryParams, undefined);
    }
    async retrieveShippingServices2(carrierId) {
        const path = `/v1/shipment/services/${carrierId || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
    async voidShipment(shipmentId, queryParams) {
        const path = `/v1/shipment/void/${shipmentId || ""}`;
        return await this.request("post", path, queryParams, undefined);
    }
    async retrieveShipments(queryParams) {
        const path = `/v1/shipments`;
        return await this.request("get", path, queryParams, undefined);
    }
}
exports.SkubanaShipmentApiClient = SkubanaShipmentApiClient;
